/**
 * An article's category is one text column, but feeds with several
 * <category> tags landed there as a whole list: a JSON array
 * (["Crime","Fire"]) or a Postgres array literal ({"Aeronautics","General"}).
 * Read any of those, or a plain name, as the list of categories.
 */
export function categoryList(value?: string | null): string[] {
  const raw = (value || '').trim();
  if (!raw) return [];
  let names: string[] = [raw];
  if (raw.startsWith('[') && raw.endsWith(']')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) names = parsed.map((v) => String(v ?? ''));
    } catch {
      // Not JSON after all; keep it as one name.
    }
  } else if (raw.startsWith('{') && raw.endsWith('}')) {
    names = pgArray(raw.slice(1, -1));
  }
  const seen = new Set<string>();
  const out: string[] = [];
  for (const name of names) {
    const clean = name.trim();
    if (clean && !seen.has(clean)) {
      seen.add(clean);
      out.push(clean);
    }
  }
  return out;
}

/** The first category: what a row or a breadcrumb shows. */
export function primaryCategory(value?: string | null): string {
  return categoryList(value)[0] || '';
}

/** The inside of a Postgres text[] literal: quoted or bare items, comma separated. */
function pgArray(body: string): string[] {
  const out: string[] = [];
  let i = 0;
  while (i < body.length) {
    while (body[i] === ' ' || body[i] === ',') i += 1;
    if (i >= body.length) break;
    let item = '';
    if (body[i] === '"') {
      i += 1;
      while (i < body.length && body[i] !== '"') {
        if (body[i] === '\\' && i + 1 < body.length) i += 1;
        item += body[i];
        i += 1;
      }
      i += 1;
    } else {
      while (i < body.length && body[i] !== ',') {
        item += body[i];
        i += 1;
      }
      if (item.trim().toUpperCase() === 'NULL') item = '';
    }
    out.push(item);
  }
  return out;
}
